import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  NavLink,
} from "react-router-dom";
import { useState } from "react";
import Home from "./componants/home/Home";
import Services from "./componants/services/Services";
import ContactUs from "./componants/contactus/ContactUs";
import About from "./componants/aboutus/about";
import BookAppointment from "./componants/book/BookAppointment";
import logo from "./assets/logo/logo.jpg";
import {
  Heart,
  Phone,
  MapPin,
  Menu,
  X,
  Users,
  Mail,
  Facebook,
  Instagram,
  Clock,
  Award,
  Shield,
  MessageCircle,
} from "lucide-react";

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <Router>
      {/* HEADER */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Top Bar */}
          <div className="flex justify-between items-center py-3 border-b border-gray-100">
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-sm">
                <Phone className="w-4 h-4" style={{ color: "#f5a09e" }} />
                <a
                  href="tel:+16045127113"
                  className="text-gray-700 hover:text-[#f5a09e] transition-colors"
                >
                  +1 604-512-7113
                </a>
              </div>
              <div className="hidden sm:flex items-center gap-2 text-sm">
                <MapPin className="w-4 h-4" style={{ color: "#f5a09e" }} />
                <span className="text-gray-700">
                  6710 123a Street, Surrey, BC, V3W 0Z1 Canada
                </span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/share/1C3J1XDjKu/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-[#f5a09e] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/heartland_care_services/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-[#f5a09e] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Main Navigation */}
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center gap-3">
              <NavLink to="/">
                <img
                  src={logo}
                  alt="Logo"
                  className="w-32 h-auto cursor-pointer"
                />
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "text-[#65c063] font-semibold transition-colors"
                    : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                }
              >
                Home
              </NavLink>
              <NavLink
                to="/aboutus"
                className={({ isActive }) =>
                  isActive
                    ? "text-[#65c063] font-semibold transition-colors"
                    : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                }
              >
                About Us
              </NavLink>
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  isActive
                    ? "text-[#65c063] font-semibold transition-colors"
                    : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                }
              >
                Services
              </NavLink>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive
                    ? "text-[#65c063] font-semibold transition-colors"
                    : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                }
              >
                Contact
              </NavLink>
              <Link to="/book">
                <button
                  className="text-white px-6 py-2.5 rounded-full font-medium hover:shadow-lg transition-all"
                  style={{
                    background: "linear-gradient(135deg, #65c063, #29a060)",
                  }}
                >
                  Book Appointment
                </button>
              </Link>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-700"
            >
              {mobileMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>

          {/* Mobile Navigation */}
          {/* {mobileMenuOpen && (
            <nav className="md:hidden py-4 border-t border-gray-100">
              <div className="flex flex-col gap-4">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Home
                </NavLink>
                <NavLink
                  to="/aboutus"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  About Us
                </NavLink>
                <NavLink
                  to="/services"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Services
                </NavLink>
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Contact
                </NavLink>
                <Link to="/book">
                  <button
                    className="text-white px-6 py-2.5 rounded-full font-medium w-full"
                    style={{
                      background: "linear-gradient(135deg, #65c063, #29a060)",
                    }}
                  >
                    Book Appointment
                  </button>
                </Link>
              </div>
            </nav>
          )} */}
          {mobileMenuOpen && (
            <nav className="md:hidden py-4 border-t border-gray-100">
              <div className="flex flex-col gap-4">
                <NavLink
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Home
                </NavLink>
                <NavLink
                  to="/aboutus"
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  About Us
                </NavLink>
                <NavLink
                  to="/services"
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Services
                </NavLink>
                <NavLink
                  to="/contact"
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    isActive
                      ? "text-[#65c063] font-semibold transition-colors"
                      : "text-gray-700 hover:text-[#f5a09e] transition-colors font-medium"
                  }
                >
                  Contact
                </NavLink>
                <Link to="/book" onClick={() => setMobileMenuOpen(false)}>
                  <button
                    className="text-white px-6 py-2.5 rounded-full font-medium w-full"
                    style={{
                      background: "linear-gradient(135deg, #65c063, #29a060)",
                    }}
                  >
                    Book Appointment
                  </button>
                </Link>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/book" element={<BookAppointment />} />
      </Routes>
      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3">
                <NavLink to="/">
                  <img
                    src={logo}
                    alt="Logo"
                    className="w-32 h-auto cursor-pointer"
                  />
                </NavLink>
              </div>
              <p className="text-sm">
                Providing compassionate home care services across Surrey and
                surrounding areas since 2020.
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    to="/"
                    className="hover:text-[#f5a09e] transition-colors"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aboutus"
                    className="hover:text-[#f5a09e] transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/services"
                    className="hover:text-[#f5a09e] transition-colors"
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="hover:text-[#f5a09e] transition-colors"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Services</h4>
              <ul className="space-y-2 text-sm">
                <li>Personal Care</li>
                <li>Companionship</li>
                <li>Homemaking</li>
                <li>Respite Care</li>
                <li>Dementia Care</li>
                <li>Palliative Care</li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Contact Info</h4>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start gap-2">
                  <MapPin
                    className="w-4 h-4 mt-1 flex-shrink-0"
                    style={{ color: "#f5a09e" }}
                  />
                  <span>6710 123a Street, Surrey, BC, V3W 0Z1 Canada</span>
                </li>
                <li className="flex items-start gap-2">
                  <Phone
                    className="w-4 h-4 mt-1 flex-shrink-0"
                    style={{ color: "#f5a09e" }}
                  />
                  <a
                    href="tel:+16045127113"
                    className="hover:text-[#f5a09e] transition-colors"
                  >
                    +1 604-512-7113
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm">
              © 2025 Heartland Care Services Inc. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.facebook.com/share/1C3J1XDjKu/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f5a09e] transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/heartland_care_services/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#f5a09e] transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </Router>
  );
}

export default App;
